export const DISPLAY_CURRENCY = 'USD';
